import React from 'react';
import { Dropdown } from 'react-bootstrap';

const DropDown = ({ className, drpDwnText, drpItems, onSelect }) => {
    return (
        <Dropdown className={className}>
            <Dropdown.Toggle as="div" >
                {drpDwnText}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {drpItems.filter(Boolean).map((item, index) => (
                    <Dropdown.Item key={index} onClick={() => onSelect(item.id)}>
                        {item?.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default DropDown;
